import { Cart } from "@commercetools/platform-sdk"
import { TFunction } from "i18next"
import { useTranslation } from "react-i18next"
import { ErrorType } from "../../../error/ErrorType"
import {
  success,
  useValidationStrategy,
  CartValidationBase,
  cartSuccess
} from "../../validation/FormValidator"
import {
  error,
  ValidationResult,
  CartValidationResult,
  cartError
} from "../../validation/ValidationError"

export const useShippingMethodValidation = (cart: Cart | undefined) => {
  const { t } = useTranslation("checkout")
  let c = cart
  return useValidationStrategy(() => true, {
    name: "ShippingMethodValidation",
    refreshCart: newCart => (c = newCart),
    validate(): ValidationResult {
      if (!c?.shippingInfo) {
        return error(ErrorType.ShippingMethodError, {
          message: t("chooseYourShippingMethod")
        })
      }
      return success()
    },
    save(): ValidationResult {
      return success()
    }
  })
}

export class ShippingMethodValidation extends CartValidationBase {
  private readonly t: TFunction
  constructor(t: TFunction) {
    super("ShippingMethodValidation")
    this.t = t
  }

  validate(c: Cart): CartValidationResult {
    if (!c?.shippingInfo) {
      return cartError(ErrorType.ShippingMethodError, {
        message: this.t("checkout.chooseYourShippingMethod")
      })
    }
    return cartSuccess(c)
  }
}
